module.exports = __webpack_public_path__ + "img/nz.652a4a54.svg";